/* istanbul ignore file */

// generated by scripts/combine-translations.mjs

export const languageFiles: Record<
  string,
  () => Promise<{ default: unknown }>
> = {
  ['de']: () => import('./de.json'),
  ['en']: () => import('./en.json'),
  ['es']: () => import('./es.json'),
  ['fr']: () => import('./fr.json'),
  ['it']: () => import('./it.json'),
  ['ja']: () => import('./ja.json'),
  ['nl']: () => import('./nl.json'),
  ['pt-BR']: () => import('./pt-BR.json'),
  ['sv']: () => import('./sv.json'),
};
